import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialDemoPage() {
    const navigate = useNavigate();

    return (
        <div style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column', background: '#f8fafc', overflow: 'hidden', fontFamily: 'Inter, sans-serif' }}>
            {/* Fake Header */}
            <header style={{ height: 70, background: 'white', borderBottom: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', padding: '0 30px', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
                    <div style={{ width: 35, height: 35, background: '#4f46e5', borderRadius: 8, display: 'grid', placeItems: 'center', color: 'white', fontWeight: 'bold' }}>IC</div>
                    <span style={{ fontWeight: 700, fontSize: '1.2rem', color: '#1e293b' }}>Tableau de Bord</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                    <div style={{ padding: '8px 16px', background: '#ecfdf5', color: '#059669', borderRadius: 50, fontSize: '0.9rem', fontWeight: 600 }}>🟢 En ligne</div>
                    <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#e2e8f0', overflow: 'hidden' }}>
                        <img src="https://images.unsplash.com/photo-1556157382-97eda2d62296?auto=format&fit=crop&w=100&q=80" alt="Client" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                </div>
            </header>

            {/* Content */}
            <main style={{ flex: 1, padding: 40, overflowY: 'auto' }}>
                {/* Welcome Banner */}
                <div style={{ marginBottom: 40 }}>
                    <h1 style={{ fontSize: '2rem', color: '#0f172a', marginBottom: 10 }}>Bonjour, Alex ! 👋</h1>
                    <p style={{ color: '#64748b' }}>Voici ce qu'il se passe sur votre site aujourd'hui.</p>
                </div>

                {/* Stats Grid - The "Wow" Factor */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24, marginBottom: 40 }}>
                    <StatCard title="Visiteurs en temps réel" value="124" trend="+12%" icon="👥" color="#3b82f6" />
                    <StatCard title="Ventes ce mois" value="15,430 €" trend="+24%" icon="💰" color="#10b981" />
                    <StatCard title="Commandes" value="84" trend="+8%" icon="📦" color="#f59e0b" />
                    <StatCard title="Avis Clients" value="4.9/5" trend="Top" icon="⭐" color="#8b5cf6" />
                </div>

                {/* Main Visual - Fake Chart */}
                <div style={{ background: 'white', borderRadius: 20, padding: 30, border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)', marginBottom: 30, height: 300, display: 'flex', alignItems: 'flex-end', gap: 20, position: 'relative' }}>
                    <h3 style={{ position: 'absolute', top: 30, left: 30, margin: 0, color: '#64748b' }}>Performance des ventes (Derniers 7 jours)</h3>
                    {[40, 65, 45, 80, 55, 90, 100].map((h, i) => (
                        <div key={i} style={{ flex: 1, background: i === 6 ? '#4f46e5' : '#e2e8f0', height: `${h}%`, borderRadius: '8px 8px 0 0', position: 'relative', transition: 'all 0.3s' }}>
                            {i === 6 && <div style={{ position: 'absolute', top: -40, left: '50%', transform: 'translateX(-50%)', background: 'black', color: 'white', padding: '4px 8px', borderRadius: 6, fontWeight: 700 }}>Record!</div>}
                        </div>
                    ))}
                </div>

                {/* Recent Activity List */}
                <div style={{ background: 'white', borderRadius: 20, padding: 30, border: '1px solid #e2e8f0' }}>
                    <h3 style={{ margin: '0 0 20px 0', color: '#0f172a' }}>Dernières commandes</h3>
                    {[1, 2, 3].map(i => (
                        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '15px 0', borderBottom: i < 3 ? '1px solid #f1f5f9' : 'none' }}>
                            <div style={{ display: 'flex', gap: 15 }}>
                                <div style={{ width: 40, height: 40, background: '#f1f5f9', borderRadius: 8, display: 'grid', placeItems: 'center' }}>🛍️</div>
                                <div>
                                    <div style={{ fontWeight: 600, color: '#1e293b' }}>Commande #{2034 + i}</div>
                                    <div style={{ fontSize: '0.9rem', color: '#64748b' }}>Il y a {i * 12} minutes</div>
                                </div>
                            </div>
                            <div style={{ fontWeight: 700, color: '#10b981' }}>+ 129.00 €</div>
                        </div>
                    ))}
                </div>
            </main>

            {/* Warning Banner - "Demo Mode" */}
            <div style={{ background: '#1e293b', color: 'white', padding: 15, textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20 }}>
                <span>🎭 <b>Mode Démonstration</b> - Les données affichées sont fictives.</span>
                <button
                    onClick={() => navigate('/commercial/launchpad')}
                    style={{ background: 'white', color: 'black', border: 'none', padding: '8px 16px', borderRadius: 50, fontWeight: 700, cursor: 'pointer' }}
                >
                    Quitter la démo
                </button>
            </div>
        </div>
    );
}

function StatCard({ title, value, trend, icon, color }) {
    return (
        <div style={{ background: 'white', borderRadius: 20, padding: 24, border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', gap: 10, boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ width: 40, height: 40, borderRadius: 10, background: `${color}20`, color: color, display: 'grid', placeItems: 'center', fontSize: '1.2rem' }}>{icon}</div>
                <div style={{ color: '#10b981', background: '#ecfdf5', padding: '4px 8px', borderRadius: 50, fontSize: '0.8rem', fontWeight: 700 }}>{trend}</div>
            </div>
            <div>
                <div style={{ fontSize: '0.9rem', color: '#64748b', marginBottom: 4 }}>{title}</div>
                <div style={{ fontSize: '2rem', fontWeight: 800, color: '#0f172a' }}>{value}</div>
            </div>
        </div>
    );
}
